import { menuFr as libMenuFr } from '@rfc/rfc-components-library/locales'

export const menuFr = {
    ...libMenuFr,
    checkpoints: 'Checkpoints',
    events: 'Évènements',

    adminHubMenu: 'Administration uRTime',
    stats: 'Statistiques'
}
